import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomPanel, Loading, PageHeader } from '../../../../../components'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { getLeftoverProductByFleetId } from '../../../../../services/api/https/deliveries/retorno.http'
import SobrasDataTable from '../Sobra/SobraDataTable'

function Sobras({ history, dispatch }) {
  // Vars
  const {
    location: {
      state: { fleet_id, vehicle_badge },
    },
  } = history

  // Hooks
  const [ocorrenciasSobras, setOcorrenciasSobras] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getOcorrenciaSobras()
  }, [fleet_id])

  // Helpers

  const getOcorrenciaSobras = async () => {
    try {
      const fetchedOcorrencias = await getLeftoverProductByFleetId(fleet_id)

      setOcorrenciasSobras(fetchedOcorrencias)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>Ocorrências de Sobra &nbsp;</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div>
            {isLoading ? (
              <div className="text-center">
                <Loading />
              </div>
            ) : (
              <SobrasDataTable
                ocorrencias={ocorrenciasSobras}
                setOcorrencias={setOcorrenciasSobras}
                getOcorrenciaSobras={getOcorrenciaSobras}
                dispatch={dispatch}
                fleetId={fleet_id}
                vehicleBadge={vehicle_badge}
              />
            )}
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(Sobras))
